import styled from "styled-components";
import {
  BORDER_COLORS,
  LAYER_COLORS,
} from "../../../constants/design/colors";

export const TickerLogoWrapper = styled.span<{
  $size: number;
  rounded: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: ${({ rounded }) => (rounded ? "50%" : "6px")};
  overflow: hidden;
  background-color: ${LAYER_COLORS.two};
  box-shadow: inset 0 0 0 1px ${BORDER_COLORS.one};

  img,
  svg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;
